import React from 'react'
import { Main } from './components/Main';


export const HomePage = () => {
  return (
    <div>    
      <main className="main-wrap">
        <Main />
      </main> 
    </div>
  );
}
